import React from 'react';
import AddIcon from '@mui/icons-material/Add';

const RegistryFilter = ({
  filterKind,
  setFilterKind,
  query,
  setQuery,
  kinds,
  onNavigateBack,
  onCreateNew,
  theme,
  styles,
  breadcrumb
}) => {
  const filterBtn = (active) => ({
    ...styles.btn,
    background: active
      ? (theme.name === 'dark' ? 'rgba(37, 99, 235, 0.18)' : 'rgba(37, 99, 235, 0.10)')
      : styles.btn.background,
    borderColor: active ? '#2563eb' : styles.btn.borderColor,
    color: theme.toolbar.text,
    fontWeight: 700
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
      {/* Breadcrumb row */}
      {breadcrumb && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, opacity: 0.8 }}>
          {breadcrumb}
        </div>
      )}

      {/* Controls row */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <button style={styles.btn} onClick={onNavigateBack}>
          ← К диаграммам
        </button>

        {kinds && kinds.length > 0 && (
          <div style={{ display: 'flex', gap: 4, marginLeft: 8 }}>
            <button style={filterBtn(filterKind === 'all')} onClick={() => setFilterKind('all')}>
              Все
            </button>
            {kinds.map(k => (
              <button
                key={k.slug}
                style={filterBtn(filterKind === k.slug)}
                onClick={() => setFilterKind(k.slug)}
              >
                {k.name}
              </button>
            ))}
          </div>
        )}

        <button
          style={{
            ...styles.primaryBtn,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
          onClick={onCreateNew}
        >
          <AddIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} /> Создать
        </button>

        <div style={{ flex: 1 }} />

        <input
          type="text"
          placeholder="Поиск по названию, коду, тегам..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={styles.searchInputStyle}
        />
      </div>
    </div>
  );
};

export default RegistryFilter;
